module.exports = __webpack_public_path__ + "img/companies_01.6782100d.jpeg";